import { IGetState } from '../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { snackbarSuccessDefault } from '../../../../snackbarsStack';
import { getMessages } from '../../../../../../store/constants';

export const onCopyEmail = (
    email: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(email).then(() => {
                dispatch(snackbarSuccessDefault({
                    id: 'SNACKBAR_ID_EMAIL_COPIED',
                    text: getMessages().getText('profile.email_copy')
                }));
            });
        }
    };
    return action;
};
